import { render, staticRenderFns } from "./ReservationPanel.vue?vue&type=template&id=6772d3e1&scoped=true&"
import script from "./ReservationPanel.vue?vue&type=script&lang=js&"
export * from "./ReservationPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPanel.vue?vue&type=style&index=0&id=6772d3e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6772d3e1",
  null
  
)

export default component.exports